import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/ka'

export const DayjsLocalManager = (locale: string) => {
  dayjs.locale(locale)
}
